import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import {ActivityTotalModel} from '../../api/models/activity-total-model';

@Injectable()
export class ActivityDashboardService {

  public dashboardData: ActivityTotalModel = {
    grandTotals: [],
    topByNumber: [],
    topByGroup: [],
    topByUser: [],
    timeSeriesTotals: []
  };

  public selectedRefreshTitle = 'Auto Refresh - Off';
  public selectedRefreshTime = 0;
  public refreshRanges = [
    {action: 0, text: 'Auto Refresh - Off'},
    {action: 10, text: 'Every 10 sec'}
  ];

  public topRanges = [
    {action: 1, text: 'Top 1'},
    {action: 2, text: 'Top 2'},
    {action: 3, text: 'Top 3'},
    {action: 4, text: 'Top 4'},
    {action: 5, text: 'Top 5'},
    {action: 6, text: 'Top 6'}
  ];

  public chartRanges = [
    {action: 1, text: '1 Hour'},
    {action: 6, text: '6 Hours'},
    {action: 24, text: '1 Day'}
  ];

  public chartSelectedItem;
  public topNumberRangeSelectedItem;
  public topGroupRangeSelectedItem;
  public topUserRangeSelectedItem;

  constructor(private authService: AuthService, private reportsApiService: ReportsApiService) {
    this.topNumberRangeSelectedItem = this.topRanges[2];
    this.topGroupRangeSelectedItem = this.topRanges[2];
    this.topUserRangeSelectedItem = this.topRanges[2];
    this.chartSelectedItem = this.chartRanges[1];
  }

  onRefreshRangeChange(selectedItem: any) {
    console.log(selectedItem);
    this.selectedRefreshTitle = selectedItem.text;
    this.selectedRefreshTime = selectedItem.action;
  }

}
